import { render, staticRenderFns } from "./NavList.vue?vue&type=template&id=bd41d312&scoped=true"
import script from "./NavList.vue?vue&type=script&lang=js"
export * from "./NavList.vue?vue&type=script&lang=js"
import style0 from "./NavList.vue?vue&type=style&index=0&id=bd41d312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd41d312",
  null
  
)

export default component.exports